import classes from "./InstitutionManagementPage.module.css";
import NormalPagination from "../../components/pagination/NormalPagination";
import React, {Fragment, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useGlobalFilter, usePagination, useTable} from "react-table";
import {
    TEXTBOX
} from "../../utils/constants";
import {Table} from "react-bootstrap";
import {ReactComponent as NoResultImage} from "../../images/no-result-found.svg";
import {ReactComponent as INS_ACCESS} from "../../images/user_settings_purple_icon.svg";
import TableSortHeaderNew from "../../components/TableSortHeaderNew";
import {YuJaKebabMenuNew} from "../../components/standardization/YuJaKebabMenuNew";

export default function CSMManagementTable({columns, data, setData, globalFilterObj, onEdit, onInstitutionAccess}) {
    const {t} = useTranslation();
    const [sortedBy, setSortedBy] = useState("");

    const filterCustomize = (rows, _, globalFilterValue) => {
        if (Object.entries(globalFilterValue).length === 0) {
            return rows;
        }

        const filteredKeyword = globalFilterValue.keyword ? globalFilterValue.keyword.toLowerCase().trim() : "";

        return rows.filter(r => {
            if (!filteredKeyword) {
                return true;
            }
            const values = r.values;
            if (!!values.firstName && values.firstName.toLowerCase().indexOf(filteredKeyword) > -1) {
                return true;
            }

            if (!!values.lastName && values.lastName.toLowerCase().indexOf(filteredKeyword) > -1) {
                return true;
            }

            if (!!values.userName && values.userName.toLowerCase().indexOf(filteredKeyword) > -1) {
                return true;
            }

            if (!!values.email && values.email.toLowerCase().indexOf(filteredKeyword) > -1) {
                return true;
            }

            return false;
        });
    }


    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        state: { pageIndex},
        setGlobalFilter,
    } = useTable({
        columns,
        data,
        initialState: { pageIndex: 0, pageSize: 8},
        autoResetPage: true,
        globalFilter: filterCustomize,
    }, useGlobalFilter, usePagination);

    useEffect(() => {
        setGlobalFilter(globalFilterObj);
    }, [data, globalFilterObj]);

    const SORTABLE_HEADER = [
        t("common.emailLabel"),
        t("institution.csmUserTableUserNameHeader"),
        t("auth.firstNameLabel"),
        t("auth.lastNameLabel"),
        t("auth.roleLabel"),
        t("institution.csmUserTableGrantedAccessHeader")
    ];

    if (!page || !page.length) {
        return (
            <div className={classes.tableContainerCard}>
                <NoResultImage style={{height: 150, alignSelf: "center", margin: "20px 0"}}/>
                <span style={{alignSelf: "center", fontSize: 20, fontWeight: "600", lineHeight: 1.4}}>
                    {t("institution.noCsmFound")}
                </span>
                <span style={{alignSelf: "center"}}>
                    {t("institution.noCsmFoundDesc")}
                </span>
            </div>
        );
    }

    return (
        <>
            <div className={classes.tableContainerCard}>
                <div className={classes.tableWrapper}>
                    <Table hover {...getTableProps()}>
                        <thead>
                            {headerGroups.map((headerGroup, index) => (
                                <tr key={index} {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column, index) => (
                                        <Fragment key={index}>
                                            {SORTABLE_HEADER.includes(column.Header) &&
                                                <TableSortHeaderNew
                                                    data={data}
                                                    setData={setData}
                                                    sortedBy={sortedBy}
                                                    setSortedBy={setSortedBy}
                                                    propertyName={column.id}
                                                    label={column.render('Header')}
                                                    {...column.getHeaderProps({
                                                        style: {
                                                            width: column.width,
                                                            minWidth: column.minWidth,
                                                            textAlign: 'left',
                                                            paddingLeft: column.Header === t("common.emailLabel")
                                                                ? 20 : undefined
                                                        }
                                                    })}
                                                >
                                                    {column.render('Header')}
                                                </TableSortHeaderNew>
                                            }

                                            {column.render('Header') === t("table.actionHeader") &&
                                                <th
                                                    {...column.getHeaderProps({
                                                        style: {
                                                            width: column.width,
                                                            minWidth: column.minWidth,
                                                            textAlign: 'center'
                                                        }
                                                    })}
                                                >
                                                    <span role={TEXTBOX}>
                                                        {column.render('Header')}
                                                    </span>
                                                </th>
                                            }
                                        </Fragment>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {page.map((row, index) => {
                                prepareRow(row);
                                return (
                                    <tr key={index} {...row.getRowProps()}>
                                        {row.cells.map((cell, cellIdx) => {
                                            if (cell.column.Header === t("table.actionHeader")) {
                                                return (
                                                    <td key={cellIdx} width={80}>
                                                            <span style={{ display: "flex", justifyContent: "center" }} >
                                                                <YuJaKebabMenuNew triggerAriaLabel={`Actions for ${row.original.fullName}`}>
                                                                    <YuJaKebabMenuNew.Menu>
                                                                        {/*<YuJaKebabMenu.Item*/}
                                                                        {/*    onClick={() => onEdit(row.original)}*/}
                                                                        {/*>*/}
                                                                        {/*    <EditIcon style={{ width: 18, marginRight: 5 }} />{t("common.edit")}*/}
                                                                        {/*</YuJaKebabMenu.Item>*/}
                                                                        <YuJaKebabMenuNew.Item
                                                                            onClick={() => onInstitutionAccess(row.original)}
                                                                        >
                                                                            <INS_ACCESS />{t("institution.institutionAccess")}
                                                                        </YuJaKebabMenuNew.Item>
                                                                    </YuJaKebabMenuNew.Menu>
                                                                </YuJaKebabMenuNew>
                                                            </span>
                                                    </td>
                                                )
                                            } else {
                                                return (
                                                    <td
                                                        key={cellIdx}
                                                        style={{
                                                            paddingLeft: cell.column.Header === t("common.emailLabel") ? 20 : undefined
                                                        }}
                                                    >
                                                            <span
                                                                style={{
                                                                    display: "block",
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                    overflow: "hidden",
                                                                    width: "100%",
                                                                }}
                                                                title={!!cell.value ? cell.value : ""}
                                                            >
                                                                {cell.value}
                                                            </span>
                                                    </td>
                                                );
                                            }

                                        })}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                </div>
            </div>

            <NormalPagination
                pageCount={pageCount}
                pageIndex={pageIndex}
                pageOptions={pageOptions}
                canPreviousPage={canPreviousPage}
                canNextPage={canNextPage}
                previousPage={previousPage}
                nextPage={nextPage}
                gotoPage={gotoPage}
                paddingTop="0px"
            />
        </>
    );
}